import { Component, input, inject, computed } from '@angular/core';
import { Params, UrlTree } from '@angular/router';
import { Router } from '@services/route.service';

@Component({
  selector: 'lgb-back',
  standalone: false,
  templateUrl: './back.html',
  styleUrl: './back.css',
})
export class Back {
  readonly router=inject(Router);

  readonly link=input<string>();          //url de la route
  readonly name=input<string>();          //nom de la router
  readonly params=input<string[]>();      //params pour la route
  readonly fragment=input<string>(null);  //param pour une ancre
  readonly queryParams=input<Params>({})  //query parameter

  readonly destination=computed(() => {
    if(this.link())
      return this.link();
    else if(this.name())
      return this.router.parse(this.name(), this.params());
    else
      return this.router.getPrevious(this.queryParams(), this.fragment());
  });

  getQueryParams(){
    return ((this.link() || this.name())? this.queryParams(): null);
  }

  getFragment(){
    return ((this.link() || this.name())? this.fragment(): null);
  }
}
